import React, { useState } from 'react';
import './link-preview-card.scss';

interface LinkPreviewCardProps {
  href: string;
  title: string;
  description?: string;
  image?: string;
  siteName?: string;
}

const getHostname = (href: string): string => {
  return new URL(href).hostname.replace(/^www\./, '');
};

const LinkPreviewCard = ({
  href,
  title,
  description,
  image,
  siteName,
}: LinkPreviewCardProps) => {
  const [imageFailed, setImageFailed] = useState<boolean>(false);

  const showImage: boolean = Boolean(image) && !imageFailed;

  return (
    <a
      className="link-preview-card"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="link-preview-text">
        <p className="link-preview-title">{title}</p>
        {description && (
          <p className="link-preview-description">{description}</p>
        )}
        <span className="link-preview-domain">
          {siteName ?? getHostname(href)}
        </span>
      </div>

      {showImage && (
        <div className="link-preview-thumb">
          <img src={image} alt="" onError={() => setImageFailed(true)} />
        </div>
      )}
    </a>
  );
};

export default LinkPreviewCard;
